import React from 'react';
import CustomProvider, { CustomProviderProps } from 'rsuite/CustomProvider';
import './rsuite.less';

import { useIntl } from 'react-intl';
import { deDE, enUS, esES, fiFI, itIT, nlNL, ptBR, ruRU, frFR, csCZ } from 'rsuite/locales';
import elGR from 'app/providers/RsuiteProvider/locales/elGR';
import skSK from 'app/providers/RsuiteProvider/locales/skSK';
import srSR from 'app/providers/RsuiteProvider/locales/srSR';
import ukUA from 'app/providers/RsuiteProvider/locales/ukUA';

const LOCALES_MAP = {
  en: enUS,
  fr: frFR,
  de: deDE,
  sr: srSR,
  el: elGR,
  nl: nlNL,
  ru: ruRU,
  uk: ukUA,
  it: itIT,
  fi: fiFI,
  pt: ptBR,
  es: esES,
  sk: skSK,
  cz: csCZ,
} as const;

export default function RSuiteProvider({
  children,
  ...rest
}: React.PropsWithChildren<CustomProviderProps>) {
  const intl = useIntl();
  const locale = intl.locale as keyof typeof LOCALES_MAP;
  const rsuiteLocale = LOCALES_MAP[locale] || enUS;

  return (
    <CustomProvider {...rest} locale={rsuiteLocale}>
      {children}
    </CustomProvider>
  );
}
